var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAntiClockWiseSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "la:undo-alt",
    clipPath: "url(#clip0_14_10635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.71094 17.1982C5.19531 23.2875 4.77141 30.3498 7.07673 36.5522L1.44419 33.3003L-0.313627 36.3449L11.8649 43.3761L18.8961 31.1976L15.8515 29.4398L11.2812 37.3558C8.47205 31.6745 8.32782 24.8931 11.7556 18.9561C17.1169 9.66997 28.8828 6.51729 38.1689 11.8786C47.455 17.2399 50.6077 29.0059 45.2464 38.292C39.8851 47.5781 28.1191 50.7308 18.833 45.3694L17.0752 48.4141C28.0358 54.7422 41.9629 51.0104 48.291 40.0498C54.6191 29.0892 50.8874 15.1621 39.9268 8.83399C28.9661 2.50587 15.0391 6.23761 8.71094 17.1982Z",
    fill: "#3E1A0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_10635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.25,
    height: 56.25,
    fill: "white",
    transform: "translate(0.375 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntiClockWiseSymbol);
export default __webpack_public_path__ + "static/media/anti-clock-wise-symbol.5f2d6db8e9e81a98f7c19c70e6994518.svg";
export { ForwardRef as ReactComponent };